// Short weekday ("Mon") for a set's shift_date. Quickbase sends dates as MM-DD-YYYY,
// which Chrome's Date parser accepts but Safari's doesn't (every iPhone browser is
// Safari underneath), so `new Date(shift_date)` showed "Invalid Date" on phones.
// The parts are read by hand and built as a local date, so the weekday is the
// calendar day Quickbase says in every timezone. Blank when the date can't be read.
export const shiftWeekday = (shiftDate) => {
  const s = String(shiftDate ?? '').trim();
  const m = s.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/) || s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (!m) return '';
  const [year, month, day] = m[3].length === 4 ? [m[3], m[1], m[2]] : [m[1], m[2], m[3]];
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  if (date.getMonth() !== Number(month) - 1 || date.getDate() !== Number(day)) return '';
  return date.toLocaleDateString('en-US', { weekday: 'short' });
};

// The set's badge text: "Mon, 10-26-2026" with the weekday left off when it's unknown.
export const shiftDateLabel = (shiftDate) => {
  const weekday = shiftWeekday(shiftDate);
  return weekday ? `${weekday}, ${shiftDate}` : String(shiftDate ?? '');
};
